const SvgIcon = ({size = 28, fillColor = '#f9a928'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={''+size}
    height={''+size}
    version="1.1"
    viewBox="0 0 0.914 0.914"
  >
    <g
      fill={fillColor}
      fillOpacity="1"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.024"
      transform="translate(-4.726 -3.332)"
    >
      <circle cx="5.183" cy="3.486" r="0.155"></circle>
      <circle cx="5.183" cy="4.091" r="0.155"></circle>
      <circle
        cx="3.789"
        cy="-5.486"
        r="0.155"
        transform="rotate(90)"
      ></circle>
      <circle
        cx="3.789"
        cy="-4.881"
        r="0.155"
        transform="rotate(90)"
      ></circle>
    </g>
  </svg>
);

export default SvgIcon;
